import { createI18n } from 'vue-i18n';

/**
 * Configuración de internacionalización.
 * Idioma por defecto: español (Chile). Estructura lista para agregar más idiomas.
 */
const messages = {
  es: {
    common: {
      save: 'Guardar',
      cancel: 'Cancelar',
      delete: 'Eliminar',
      edit: 'Editar',
      create: 'Crear',
      search: 'Buscar',
      loading: 'Cargando...',
      noData: 'No hay datos',
      actions: 'Acciones',
      confirm: 'Confirmar',
      required: 'Campo requerido',
      success: 'Operación exitosa',
      error: 'Ocurrió un error',
    },
    auth: {
      login: 'Iniciar sesión',
      logout: 'Cerrar sesión',
      email: 'Correo electrónico',
      password: 'Contraseña',
      forgotPassword: '¿Olvidaste tu contraseña?',
    },
    nav: {
      dashboard: 'Panel',
      attendance: 'Asistencia',
      reports: 'Reportes',
      justifications: 'Justificativos',
      settings: 'Configuración',
      profile: 'Mi perfil',
      tenants: 'Establecimientos',
      audit: 'Auditoría',
    },
    roles: {
      super_admin: 'Super Administrador',
      admin: 'Administrador',
      director: 'Director',
      utp: 'UTP',
      teacher: 'Docente',
      guardian: 'Apoderado',
      student: 'Estudiante',
    },
  },
};

export const i18n = createI18n({
  legacy: false,
  locale: 'es',
  fallbackLocale: 'es',
  messages,
});

export default i18n;
